import ActivityItem from "../../components/ActivityItem";
import SectionHeader from "../../components/SectionHeader";
import DotSlider from "./DotSlider";
import styles from "../styles/PopularActivity.module.scss";
import {
  ActivityItemProps,
  ActivityListProps,
} from "../../interfaces/ActivityInterface";

import React, { useState, useEffect } from "react";

export default function PopularActivityList({
  activities,
  setActivityDetail,
}: {
  activities: ActivityItemProps[];
  setActivityDetail: (toggleStatus: number, id: string) => void;
}) {
  // const activitiesPerSlide = 3;
  const [activitiesPerSlide, setActivitiesPerSlide] = useState(3);

  const [windthSize, setWindowSize] = useState(1440);
  const totalSlide = Math.ceil(activities.length / activitiesPerSlide);

  const [activitiesOnCurrentSlide, setActivitiesOnCurrentSlide] = useState(
    activities.slice(0, activitiesPerSlide)
  );

  const [activeDot, setActiveDot] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(1);

  useEffect(() => {
    function handleResize() {
      setWindowSize(window.innerWidth);

      // if (window.innerWidth < 1300 && window.innerWidth > 900) {
      //   setActivitiesPerSlide(2);
      // } else if (window.innerWidth <= 900) {
      //   setActivitiesPerSlide(1);
      // }

      setActivitiesOnCurrentSlide(activities.slice(0, activitiesPerSlide));
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function handleChangeSlide(currentSlide: number) {
    const startIndex = (currentSlide - 1) * activitiesPerSlide;
    const endIndex = currentSlide * activitiesPerSlide;
    setActivitiesOnCurrentSlide(activities.slice(startIndex, endIndex));
  }

  function changeSlide(newSlide: number) {
    if (newSlide > totalSlide) {
      setCurrentSlide(newSlide - 1);
      setActiveDot(newSlide - 1);
      handleChangeSlide(newSlide - 1);
    } else if (newSlide < 1) {
      setCurrentSlide(newSlide + 1);
      setActiveDot(newSlide + 1);
      handleChangeSlide(newSlide + 1);
    } else {
      setCurrentSlide(newSlide);
      setActiveDot(newSlide);
      handleChangeSlide(newSlide);
    }
  }

  const showDotCarousel = (currentSlide) => {
    const dot = [];
    for (let i = 0; i < totalSlide; i++) {
      if (currentSlide - 1 == i) {
        dot.push(
          <DotSlider
            key={i}
            dotSlider={i}
            activeSlide={styles.active}
            changeSlide={changeSlide}
          />
        );
      } else {
        dot.push(
          <DotSlider
            key={i}
            dotSlider={i}
            activeSlide={""}
            changeSlide={changeSlide}
          />
        );
      }
    }
    return dot;
  };

  return (
    <div className={styles.popular_activity_section}>
      <SectionHeader>Popular Activities</SectionHeader>
      <div className={styles.carousel_popular}>
        <button
          id={styles.left_btn}
          onClick={() => changeSlide(currentSlide - 1)}
        ></button>

        <div className={styles.popular_list}>
          {activitiesOnCurrentSlide.map((value, index) => {
            return (
              <div key={index}>
                <div className={`${styles.fade} ${styles.popularItem}`}>
                  <ActivityItem
                    key={index}
                    activity={value}
                    setActivityDetail={setActivityDetail}
                  />
                </div>
              </div>
            );
          })}
        </div>

        <button
          id={styles.right_btn}
          onClick={() => changeSlide(currentSlide + 1)}
        ></button>
      </div>
      <div className={styles.dot_in_pic}>{showDotCarousel(currentSlide)}</div>
    </div>
  );
}
